import { QRCodeCanvas } from "qrcode.react";
import { shallowEqual, useSelector } from "react-redux";
import Loading from "./UI/Loading";

const QrCode = ({ SecretKey, UserName, qrCodeUrl = "" }) => {
  const { theme } = useSelector(
    (state) => ({
      theme: state.ui.theme,
    }),
    shallowEqual,
  );
  const isDark = theme === "dark";

  return (
    <>
      {qrCodeUrl ? (
        <QRCodeCanvas
          value={qrCodeUrl}
          size={200}
          bgColor={isDark ? "#252829" : "#f5f8fa"}
          fgColor={isDark ? "#ffffff" : "#000000"}
          level="H" // important for logo support
          imageSettings={{
            src: "/assets/images/logo.png", // public folder image
            x: undefined,
            y: undefined,
            height: 50,
            width: 50,
            // excavate: true,
          }}
        />
      ) : (
        <>
          <Loading />
        </>
      )}
    </>
  );
};

export default QrCode;
